export default __webpack_public_path__ + "static/media/noimage.e17fd2f9.jpg";